import type { EnteredOptionInput } from '@pylot-data/pylotschema'
import {
    GiftCardProductInputArgs,
    GiftProductOptionsValueUid
} from './GiftCardProduct'

//form filed name and uid reference in the query gift_cart_options
//these fields are hardcoded in the BE and not configurable from admin
export enum MapFormToFieldUid {
    'Custom Giftcard Amount' = 'gift_open_amounts',
    'Recipient Email' = 'receiver_email',
    'Recipient Name' = 'receiver_name',
    'Sender Email' = 'sender_email',
    'Sender Name' = 'sender_name',
    'Message' = 'gift_message'
}

export type GetMapFieldWithArgs = {
    giftCardOptions: GiftProductOptionsValueUid[]
    formInput: GiftCardProductInputArgs
}

export const getMapFieldWithUid = ({
    giftCardOptions,
    formInput
}: GetMapFieldWithArgs): Array<EnteredOptionInput> => {
    const enteredOptions: EnteredOptionInput[] = []

    giftCardOptions.forEach((option: GiftProductOptionsValueUid) => {
        const value =
            formInput[
                MapFormToFieldUid[
                    option?.title as keyof typeof MapFormToFieldUid
                ]
            ]
        if (value) {
            enteredOptions.push({
                uid: option?.value?.uid,
                value: String(value)
            })
        }
    })

    return enteredOptions
}
